// src/index.js o src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { loadAndApplyActiveTheme } from './components/Sistema/Utils/ThemeManager';
import { LogoProvider } from './context/LogoProvider';
import axios from 'axios';

// --- INICIO: Interceptor Global (Opción 1) Anti-Doble Clic ---
let activeRequests = 0;

const showOverlay = () => {
  let overlay = document.getElementById('global-axios-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'global-axios-overlay';
    Object.assign(overlay.style, {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100vw',
      height: '100vh',
      zIndex: '999999',
      backgroundColor: 'rgba(255, 255, 255, 0.4)', // Ligero color blanco transparente
      cursor: 'wait', // Pone el cursor de "Cargando..."
    });
    document.body.appendChild(overlay);
  }
};

const hideOverlay = () => {
  const overlay = document.getElementById('global-axios-overlay');
  if (overlay) {
    overlay.remove();
  }
};

// Interceptor de REQUEST
axios.interceptors.request.use((config) => {
  // Si la petición va a modificar datos, encendemos el bloqueo
  const method = config.method?.toLowerCase();
  if (['post', 'put', 'delete', 'patch'].includes(method)) {
    activeRequests++;
    //showOverlay();
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Interceptor de RESPONSE
axios.interceptors.response.use((response) => {
  const method = response.config?.method?.toLowerCase();
  if (['post', 'put', 'delete', 'patch'].includes(method)) {
    activeRequests--;
    if (activeRequests <= 0) {
      activeRequests = 0;
      hideOverlay();
    }
  }
  return response;
}, (error) => {
  const method = error.config?.method?.toLowerCase();
  if (['post', 'put', 'delete', 'patch'].includes(method)) {
    activeRequests--;
    if (activeRequests <= 0) {
      activeRequests = 0;
      hideOverlay();
    }
  }
  return Promise.reject(error);
});
// --- FIN: Interceptor Global ---

// Cargar y aplicar variables de identidad visual desde la BD al iniciar
loadAndApplyActiveTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <LogoProvider>
      <App />
    </LogoProvider>
  </BrowserRouter>
);
